import React, { useContext, useEffect, useState } from 'react';

const User = () => {
  return <div>User</div>;
};

export default User;
